var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgContract = function SvgContract(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    "data-width-72": 52,
    viewBox: "0 0 11.7 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M9.834 8.5a.667.667 0 0 0-.667-.667m0 2.667a2 2 0 1 0-1.915-1.419l-1.988 1.988a.33.33 0 0 0-.098.236v.862a.333.333 0 0 0 .334.333h.667a.333.333 0 0 0 .333-.333.333.333 0 0 1 .333-.334.333.333 0 0 0 .334-.333.333.333 0 0 1 .333-.333h.195a.33.33 0 0 0 .236-.098l.655-.655a2 2 0 0 0 .58.086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.167 5.5v-.579a2 2 0 0 0-.577-1.405L8.198 1.095A2 2 0 0 0 6.775.5H2.5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h1.333m-.839-8.167h5.33M3.004 6.5h3.164M3.003 8.833H4.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContract);
export default ForwardRef;